import { render } from "./clere-title.vue?vue&type=template&id=1cef071b&scoped=true"
import script from "./clere-title.vue?vue&type=script&lang=ts"
export * from "./clere-title.vue?vue&type=script&lang=ts"

import "./clere-title.vue?vue&type=style&index=0&id=1cef071b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cef071b"

export default script